export enum SettingsMenuItem {
  Unknown,
  Preferences,
  CustomSettings,
  NmvsProviderCredentials
}


// WEBPACK FOOTER //
// ./src/types/settings-menu-item.ts